module.exports = __webpack_public_path__ + "static/HeriSurotoMDPhD-f05b18e2344212cc61e87b203126ed10.jpg";